import { render, staticRenderFns } from "./batchTagsPopup.vue?vue&type=template&id=e0267052&scoped=true&"
import script from "./batchTagsPopup.vue?vue&type=script&lang=js&"
export * from "./batchTagsPopup.vue?vue&type=script&lang=js&"
import style0 from "./batchTagsPopup.vue?vue&type=style&index=0&id=e0267052&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0267052",
  null
  
)

export default component.exports